module.exports = __webpack_public_path__ + "media/images/family-homelessness-graph-2023-417090808dd9711aec64ab3209bc00c9.svg";